import {defineStore} from 'pinia'
import {useDevicesStore} from "@/stores/devices.js";
import {getFirstPage, onPage, onRowsUpdate} from "@/stores/_helpers.js";

export const useDevicesRecentlyViewedPageStore = defineStore('devicesRecentlyViewedPage', {
    state: () => ({
        data: undefined,
        totalRecords: 0,
        loading: true,
        params: {
            per_page: 20,
            page: 1,
            include: [
                'deviceType',
                'deviceModel',
                'deviceRevision',
                'currentFirmware',
                'targetFirmware',
                'company',
            ],
        },
        pages: [
            10,
            20,
            50,
            100,
        ]
    }),
    getters: {
        getDevices: (state) => {
            return state.data?.data;
        },
        getFirstPage: (state) => {
            return getFirstPage(state.params)
        }
    },
    actions: {
        onPage($event) {
            onPage($event, this.params);
            this.loadData();
        },
        onRowsUpdate(rowCount) {
            onRowsUpdate(rowCount, this.params);
        },
        async loadData() {
            const devicesStore = useDevicesStore();
            this.loading = true;
            this.data = await devicesStore.indexRecentlyViewedDevices(this.params)
            this.totalRecords = this.data.total;
            this.loading = false;
        }
    },
});
